module.exports = __webpack_public_path__ + "static/media/14.17e1365c.svg";